import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Event as TEvent } from "react-big-calendar";
import { CalendarEventOutput2 } from "~@/graphql/codegen/generated";

export type SelectedEvent = (TEvent & CalendarEventOutput2) | undefined;

export interface AgendaState {
  selectedEvent: SelectedEvent;
}

const initialState: AgendaState = {
  selectedEvent: undefined,
};

const agendaSlice = createSlice({
  name: "agenda",
  initialState,
  reducers: {
    setSelectedEvent: (state, action: PayloadAction<SelectedEvent>) => {
      state.selectedEvent = action.payload;
    },
    clearSelectedEvent: (state) => {
      state.selectedEvent = undefined;
    },
  },
});

export const { setSelectedEvent, clearSelectedEvent } = agendaSlice.actions;
export default agendaSlice.reducer;
